/**
 * @name removeNonStandardCharacters
 * @description Removes any non-standard characters. Where a 'standard' character is
 *              essentially any character that can be typed on a UK QWERTY keyboard
 */
export const removeNonStandardCharacters = (string: string): string =>
  string.replace(/[^ -¯]/g, '');
